import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'
import formatSubresources from '@tabeo/sharpei/utils/formatSubresources'
import normalize from './normalizers/merchant'

const subResources = `&${formatSubresources(['managers', 'managers.user'])}`

class Merchants extends Resource {
  getInitialData() {
    return {
      items: null,
      totalCount: 0,
    }
  }

  getInitialConfig() {
    return {
      refreshInterval: 60 * 1000,
    }
  }

  async fetch(query) {
    const {
      conditions = [],
      searchQuery = query,
      limit = 10,
      offset = 0,
      orderBy: { field, direction } = { field: 'id', direction: 'desc' },
    } = this.params

    const jsonConditions = `&jsonConditions=${encodeURIComponent(
      JSON.stringify(conditions)
    )}`

    const pagination = `&limit=${limit}&offset=${offset}`

    const endpoint = searchQuery
      ? `/merchant-search?order=${field}:${direction}&searchPhrase=${encodeURIComponent(
          searchQuery
        )}`
      : `/merchants?order=${field}:${direction}`

    const {
      data: { merchants },
      totalCount,
    } = await api.get(
      `${endpoint}${jsonConditions}${pagination}${subResources}`,
      {
        responseDataPath: 'data',
      }
    )

    const normalizedMerchants = merchants.map(o => normalize(o))

    const data = {
      totalCount,
      items: normalizedMerchants,
    }

    this.data = data

    return data
  }
}

export default Merchants
export const useMerchants = createResourceHook(Merchants)
